import * as _ from "lodash";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "dataFilter"
})

export class DataFilterPipe implements PipeTransform {

    transform(array: any[], query: string, name?: string): any {
        if (query) {
            if (name) {
                return _.filter(array, row => (row[name] != null) ? row[name].toString().indexOf(query) > -1 : false);
            }
            return _.filter(array, (row) => (row.name != null) ? row.name.toString().indexOf(query) > -1 : false);
        }
        return array;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/data-filter.pipe.ts